import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ChristmasService } from 'src/app/services/christmas.service';

@Component({
  selector: 'app-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.css']
})
export class PerfilUsuarioComponent implements OnInit {
  usuario: any;
  primeiroNome = "Usuário";
  isChristmasMode: boolean = false;

  constructor(
    private router: Router,
    private location: Location,
    private christmasService: ChristmasService
  ) { }

  ngOnInit(): void {
    this.isChristmasMode = this.christmasService.isChristmasMode();
    this.usuario = JSON.parse(localStorage.getItem('user'));
    if (this.usuario && this.usuario.nome) {
      this.primeiroNome = this.usuario.nome.split(' ')[0];
    }
  }

  voltar() {
    this.router.navigate(['/modulos']);
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}

